import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=567ce0be&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nsierrar/Projects/PlentyMarkets/Repo-GitHub/MultiContentWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567ce0be')) {
      api.createRecord('567ce0be', component.options)
    } else {
      api.reload('567ce0be', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=567ce0be&", function () {
      api.rerender('567ce0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/Slider.vue"
export default component.exports